<template lang="pug">
  v-col(cols="12" class="pt-0 pb-4")
    v-card(
      class="advert-item",
      :ripple="false",
      :to="`/advert/${advertItem.id}`",
      target="_blank",
      rel="nofollow noreferrer")
      v-card-text
        v-row(justify="center")
          ItemImage(:images="advertItem.images")
          ItemDescription(
            :advertItem="this.advertItem",
            :titleText="this.titleText",
            :priceText="priceText",
            :floorText="floorText",
            :dateText="dateText",
            :duration="setDuration")
</template>

<script>
import moment from 'moment'
import ItemImage from './ItemImage'
import ItemDescription from './ItemDescription'
export default {
  name: 'AdvertListItem',
  components: { ItemDescription, ItemImage },
  props: {
    advertItem: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    types: {
      APARTMENT: 'apartment',
      ROOM: 'room',
      HOUSE: 'house',
      AREA: 'area',
      OTHER: 'other'
    }
  }),
  computed: {
    // isAuthorAdvert() {
    //   return this.$store.getters.isAuthorAdvert(this.advertItem.id)
    // },
    // isAuthenticated() {
    //   return this.$store.getters.isAuthenticated
    // },
    // isFavorite() {
    //   return this.$store.getters.isFavorite(this.advertItem.id)
    // },
    priceText() {
      let text = ''
      if (this.advertItem.price && this.advertItem.currency) {
        text = `${this.advertItem.price.toLocaleString(
          'ru-Ru'
        )} ${this.advertItem.currencyText.toLowerCase()}`
      } else {
        text = 'Цена договорная'
      }
      return text
    },
    floorText() {
      let text = ''
      if (this.advertItem.floor) {
        text = `${this.advertItem.floor} этаж`
      }
      if (this.advertItem.floors) {
        text = `${text} из ${this.advertItem.floors}`
      }

      if (
        this.advertItem.advertType === 'rentApartment' ||
        this.advertItem.advertType === 'sellApartment'
      ) {
        return text
      } else return ''
    },
    dateText() {
      return moment(this.advertItem.creationDate).format('L')
    },
    titleText() {
      let result

      if (
        this.advertItem.advertType === 'rentApartment' ||
        this.advertItem.advertType === 'sellApartment'
      ) {
        result = this.setApartmentTitle(this.advertItem)
      }

      if (
        this.advertItem.advertType === 'rentHouse' ||
        this.advertItem.advertType === 'sellHouse'
      ) {
        result = this.setHouseTitle(this.advertItem)
      }

      if (
        this.advertItem.advertType === 'rentArea' ||
        this.advertItem.advertType === 'sellArea'
      ) {
        result = this.setAreaType(this.advertItem)
      }

      if (this.advertItem.advertType === 'rentOther') {
        result = 'Аренда'
      }
      if (this.advertItem.advertType === 'sellOther') {
        result = 'Продажа'
      }

      if (this.advertItem.advertType === 'rentRoom') {
        result = this.setRoomType(this.advertItem)
      }

      return result
    },
    setDuration() {
      let result = null
      if (
        this.advertItem.advertType === 'rentApartment' ||
        this.advertItem.advertType === 'rentHouse' ||
        this.advertItem.advertType === 'rentOther' ||
        this.advertItem.advertType === 'rentArea' ||
        this.advertItem.advertType === 'rentRoom'
      ) {
        if (this.advertItem.durationRent === 'longer') result = 'в месяц'
        else result = 'в сутки'
      }
      return result
    }
  },
  methods: {
    // toggleFavorite() {
    //   if (this.isFavorite) {
    //     this.$store.dispatch('REMOVE_FROM_FAVORITES', this.advertItem.id)
    //   } else {
    //     this.$store.dispatch('ADD_TO_FAVORITES', this.advertItem.id)
    //   }
    // },
    setApartmentTitle(advertItem) {
      let text = 'Квартира'
      if (advertItem.roomCount) {
        text = text + `, ${advertItem.roomCount}-комнатная`
      }
      if (advertItem.totalArea) {
        text = text + `, ${advertItem.totalArea} м2`
      }
      return text
    },
    setHouseTitle(advertItem) {
      let text = 'Дом'
      if (advertItem.houseArea) {
        text = text + `, ${advertItem.houseArea} м2`
      }
      return text
    },
    setAreaType(advertItem) {
      let text = 'Участок'
      if (advertItem.landArea) {
        text = text + `, ${advertItem.landArea} соток`
      }
      return text
    },
    setRoomType(item) {
      let text = 'Комната'
      if (item.roomArea) {
        text = text + `, ${item.roomArea} м2`
      }
      return text
    }
  }
}
</script>

<style lang="scss" scoped>
.advert-item:hover {
  box-shadow: 0 0 20px rgba(61, 90, 254, 0.4);
}
.advert-item {
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.147044);
  border-radius: 6px;
}
</style>
